import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import reportWebVitals from './reportWebVitals';
import App from './App';

// Get the root element from the HTML
const root = ReactDOM.createRoot(document.getElementById('root'));

// Render the root component with routing context
root.render(
  <React.StrictMode>
      <App />
  </React.StrictMode>
);

// For measuring performance in your app
reportWebVitals();
